<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="host"
    [label]="'Host' | translate"
    [required]="true"
    [tooltip]="helptext.host_sftp.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="port"
    type="number"
    [label]="'Port' | translate"
    [tooltip]="helptext.port_sftp.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="user"
    [label]="'Username' | translate"
    [required]="true"
    [tooltip]="helptext.user_sftp.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="pass"
    type="password"
    [label]="'Password' | translate"
    [tooltip]="helptext.pass_sftp.tooltip | translate"
  ></ix-input>

  <ix-select
    formControlName="private_key"
    [label]="'Private Key' | translate"
    [options]="privateKeys$"
    [tooltip]="helptext.private_key_sftp.tooltip | translate"
  ></ix-select>
</ix-fieldset>
